import styled from 'styled-components/macro';
import { pxtorem } from '~/utils/tools';
import { Wrapper } from '~/styles/Wrapper.styled';

export const StyledSingleFeaturedProduct = styled.div`
  position: relative;
  padding: 70px 20px 20px;

  & .background {
    position: absolute;
    inset: 0;
    z-index: 1;
    overflow: hidden;

    & .gatsby-image-wrapper {
      height: 100%;
      display: block;
    }
  }

  & ${Wrapper} {
    position: relative;
    z-index: 2;
    text-align: center;
    max-width: 335px;

    @media (min-width: 768px) {
      display: flex;
      justify-content: space-around;
      align-items: center;
      max-width: var(--width);
      min-height: 70vh;
      gap: 40px;

      & .text {
        flex: 1;
        max-width: 450px;
        text-align: left;
      }

      & .product {
        flex: 1;
        max-width: 360px;
      }
    }
  }

  & .text {
    color: var(--white);
    margin-bottom: 40px;

    & h4 {
      font-size: 12px;
      font-weight: 400;
      margin: 0 0 .5em;
      text-transform: uppercase;
    }

    & h3 {
      font-size: ${pxtorem(40)};
      font-weight: 400
      margin: 0 0 .5em;
    }

    & p {
      font-size: ${pxtorem(16)};
      font-weight: 400;
      line-height: 1.2;
    }

    @media (min-width: 768px) {
      & h4 {
        font-size: ${pxtorem(16)};
      }

      & h3 {
        font-size: ${pxtorem(60)};
        margin: 0 0 14px;
      }

      & p {
        font-size: ${pxtorem(20)};
      }
    }
  }
`;
